"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolveResponse(res, responseKey) {
    var data = res[responseKey];
    if (data) {
        var _a = data.responseCode, responseCode = _a === void 0 ? "0" : _a, _b = data.failureMessage, failureMessage = _b === void 0 ? {} : _b;
        if (responseCode === "1") {
            return Promise.resolve(data);
        }
        var _c = failureMessage.errorMessage, errorMessage = _c === void 0 ? "" : _c;
        return Promise.reject(Error(errorMessage));
    }
    return Promise.reject(Error("Invalid Evergent response"));
}
exports.resolveResponse = resolveResponse;
//# sourceMappingURL=Evergent.js.map